<template>
  <div class="form-group">
    <label :for="id" class="sr-only"/>
    <input
      ref="taInput"
      :id="id"
      class="form-control"
      type="text"
      :placeholder="`${setCode}.`">
    <typeahead
      v-model="standard"
      force-select
      append-to-body
      :target="taTarget"
      :async-function="queryStandards"
      item-key="standard_long_ref"
      @input="selectedStandard">
      <template slot="empty">
        <div class="text-danger">No standards found</div>
      </template>
    </typeahead>
  </div>
</template>

<script>
import { Typeahead } from 'uiv'
import { getStandardsQuery } from '@/api/pathways'

export default {
  name: 'StandardsTypeahead',
  components: {
    Typeahead
  },
  props: {
    id: {
      type: String,
      required: true
    },
    setCode: {
      type: String,
      default: 'CCSS'
    },
    standardAttributes: {
      type: Array,
      default() {
        return [
          'standard_long_ref',
          'standard_short_ref',
          'standard_text',
          'substandard_text',
          'core_purpose'
        ]
      }
    }
  },
  data() {
    return {
      fetchingStandards: false,
      standard: null,

      taTarget: null
    }
  },
  methods: {
    selectedStandard() {
      if (this.standard) {
        this.$emit('selected', this.standard)
        this.standard = null
      }
    },
    async queryStandards(query, done) {
      this.fetchingStandards = true
      try {
        let standards = await getStandardsQuery(this.setCode, {
          match_str: query,
          select_fields: this.standardAttributes
        })
        done(standards)
      } catch (err) {
        console.error('Error querying standards: ' + err)
      } finally {
        this.fetchingStandards = false
      }
    }
  },
  mounted() {
    this.taTarget = this.$refs.taInput
  }
}
</script>

<style scoped>
</style>
